import { Navigate, useParams } from 'react-router-dom';

import { PermissionsEnum } from '@/auth/interfaces';
import {
  useFetchSystemPermissions,
  useGetSystemPermissionsByGroupID,
} from '@/shared/actions/erp';
import { useCheckPermissions, useLoaders } from '@/shared/hooks';
import { SaveGrupoSistema } from '../../shared/components';
import { ROUTER_PATHS } from '@/shared';

export type UpdateGrupoSistemaPageProps = {};

const UpdateGrupoSistemaPage: React.FC<UpdateGrupoSistemaPageProps> = () => {
  useCheckPermissions(
    PermissionsEnum.auth_change_group && PermissionsEnum.auth_change_permission
  );
  const returnUrlGruposSistemaPage =
    ROUTER_PATHS.administration.grupoSistemaNav;
  const { id } = useParams();

  ///* fetch data -----------------------
  const {
    data: systemPermissionsRes,
    isLoading: isLoadingSystemPermissions,
    isRefetching: isRefetchingSystemPermissions,
  } = useFetchSystemPermissions({
    enabled: true,
    params: {
      page_size: 6000,
    },
  });
  const {
    data: groupPermissions,
    isLoading: isLoadingGroupPermissions,
    isRefetching: isRefetchingGroupPermissions,
  } = useGetSystemPermissionsByGroupID(+id!);

  const isLoadingData =
    isLoadingGroupPermissions ||
    isLoadingSystemPermissions ||
    isRefetchingSystemPermissions ||
    isRefetchingGroupPermissions;

  useLoaders(isLoadingData);

  if (isLoadingData) return null;
  if (!groupPermissions?.id)
    return <Navigate to={returnUrlGruposSistemaPage} />;

  return (
    <SaveGrupoSistema
      title="Editar Grupo de Sistema"
      gruposistema={groupPermissions}
      userPermissions={
        // filter permissions that already have the group
        systemPermissionsRes?.data.filter(permission =>
          groupPermissions?.permissions?.every(
            groupPermission => groupPermission !== permission?.id
          )
        ) || []
      }
      userPermissionsSelected={
        // pass only the permissions that the group already has as object[]
        systemPermissionsRes?.data.filter(permission =>
          groupPermissions?.permissions?.some(
            groupPermission => groupPermission === permission?.id
          )
        ) || []
      }
    />
  );
};

export default UpdateGrupoSistemaPage;
